import React, { useEffect, useState } from "react";
import Header from "./Components/Header";
import Banner from "./Components/Banner";
import BannerBottom from "./Components/BannerBottom";
import Configurator from "./Components/Configurator";
import TakeClub from "./Components/TakeClub";
import Discounts from "./Components/Discounts";
import Discover from "./Components/Discover";
import Footer from "./Components/Footer";
import Designed from "./Components/Designed";
import "./Css/fonts.css";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { useForm } from "react-hook-form";
import { config_Api, review_Api } from "../Services/Operations/ProductAPI";
import { useDispatch, useSelector } from "react-redux";
import { baseAssetUrl, ConfigUrl } from "../Redux/Cart_System";
import Offers from "./Components/Offer";
import Loader from "./Loader/Loader";
import { Star, ThumbsUp, MessageCircle, Calendar, User, Filter, Search } from 'lucide-react';
import Slider from "react-slick";
import "slick-carousel/slick/slick.css"; 
import "slick-carousel/slick/slick-theme.css";
import { SiWhatsapp } from "react-icons/si";


function Home() {
  const [showPopup, setShowPopup] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const { register, handleSubmit } = useForm();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [configUrl, setConfigUrl] = useState("");
  const { tokenDetails } = useSelector((state) => state.user);
  const [selectedFilter, setSelectedFilter] = useState('all');
  const [searchTerm, setSearchTerm] = useState('');
 // const [reviews, setReviews] = useState([]);   // fro data from backend

  const reviews = [
    {
      id: 1,
      name: "Sarah Johnson",
      avatar: "https://plus.unsplash.com/premium_photo-1690407617542-2f210cf20d7e?q=80&w=387&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
      rating: 5,
      date: "2024-01-15",
      title: "Absolutely Amazing Experience!",
      description: "This product exceeded all my expectations. The quality is outstanding and the customer service was phenomenal. I've been using it for 3 months now and it's still working perfectly. Highly recommend to anyone looking for a reliable solution.",
      verified: true,
      helpful: 24,
      category: "Product"
    },
    {
      id: 2,
      name: "Michael Chen",
      avatar: "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=150&h=150&fit=crop&crop=face",
      rating: 4,
      date: "2024-01-12",
      title: "Great value for money",
      description: "Design is as per my vision ,The fabric and fit are amazing. The design is as per my customization, and it looks the same as what was shown on the website. Just perfect. Will surely order more.",
      verified: true,
      helpful: 18,
      category: "Product"
    },
    {
      id: 3,
      name: "Emily Rodriguez",
      avatar: "https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=150&h=150&fit=crop&crop=face",
      rating: 5,
      date: "2024-01-10",
      title: "Outstanding Customer Service",
      description: "The best thing is the option to 3D customize my jersey.You can print whatever we want on them. Received really amazing football jerseys for my club. I had placed a bulk order of around 10 jerseys, and my team loved it. Good service in terms of delivery.",
      verified: true,
      helpful: 31,
      category: "Product"
    },
    {
      id: 4,
      name: "David Wilson",
      avatar: "https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=150&h=150&fit=crop&crop=face",
      rating: 3,
      date: "2024-01-08",
      title: "Good but room for improvement",
      description: "We recently ordered custom jerseys from Shield Sports for our team, and the experience was great. The quality of the jerseys was excellent, and the fit was perfect. The customization options were easy to use, and the designs turned out exactly as we wanted. The jerseys were delivered on time, and the service was smooth and professional.",
      verified: false,
      helpful: 12,
      category: "Product"
    },
    
   
  ];

  const sliderSettings = {
  dots: false,
  infinite: true,
  speed: 500,
  slidesToShow: 3,
  slidesToScroll: 1,
  arrows:false,
  responsive: [
    {
      breakpoint: 768, 
      settings: {
        slidesToShow: 1,
      },
    },
  ],
};


  useEffect(() => {
    if (!tokenDetails) {
      navigate("/", { replace: true });
    }
  }, []);



useEffect(() => {
  const fetchConfig = async () => {
    try {
      const response = await config_Api();
      const response1 = await review_Api();

      console.log("review_Api : ", response1);

      if (response.success === true) {
        dispatch(ConfigUrl(response.data.assetUrl));
        dispatch(baseAssetUrl(response.data.baseAssetUrl));
        setConfigUrl(response.data.assetUrl);
      }

      if (response1.success === true && Array.isArray(response1.data)) {
       // setReviews(response1.data);               // for data from backend
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setIsLoading(false);
    }
  };

  fetchConfig();
}, [dispatch]);


  if (isLoading) {
    return <Loader />;
  }
const renderStars = (rating) => {
  return [...Array(5)].map((_, index) => (
    <Star
      key={index}
      style={{
        width: "16px",
        height: "16px",
        color: index < rating ? "#facc15" : "#d1d5db", 
        fill: index < rating ? "#facc15" : "none",
        stroke: "#d1d5db", 
      }}
    />
  ));
};

 const filteredReviews = reviews.map((item, index) => ({
  id: index,
  name: item.name,
  avatar: `${configUrl}${item.image_path}`, 
  rating: item.star,
  title: item.title,
  description: item.description,
  date: item.updated_at,
}));


  return (
    <div  className="body-container default is-ctl-home-page is-ctl-landingpage is-ctl-navigation is-act-home"
    style={{display:"flex",flexDirection:"column",alignItems:"center"}}>

        <div
              style={{
                position: "fixed",
                bottom: "74px",
                right: "20px",
                zIndex: 10000000000,
                cursor: "pointer",
                padding:"10px",
                borderRadius:"50%",
                   boxShadow: "0 4px 30px rgba(0, 0, 0, 0.1)",
                backdropFilter: "blur(10px)",
                WebkitBackdropFilter: "blur(10px)",
                backgroundColor: "white",
              }}
              onClick={() => window.open("https://wa.me/919966774564", "_blank")}
            >
              {/* <img
                src="asset/WhatsApp.svg"
                alt="WhatsApp"
                style={{
                  width: "60px",
                  height: "60px",
                  borderRadius: "50%",
                  boxShadow: "0 2px 10px rgba(0,0,0,0.2)",
                }}
              /> */}
              <SiWhatsapp style={{fontSize:"40px",color:"green"}}/>
            </div>
      <main className="content-main">
        <div data-flashbags-container="true" className="flashbags"></div>
        <div className="container-main">
          <div className="cms-page set-banner-link-new-tab">
            <div className="cms-sections" style={{backgroundColor:"white"}}>
              <Banner />
              <BannerBottom />
              <TakeClub />
              <Configurator />
              {/* <Offers/> */}
              {/* <Designed /> */}
              <Discounts />
            </div>
          </div>
        </div>
      </main>

<div className="reviews-list" style={{margin:"0px 0px 0px 0px",minWidth:"100%",marginLeft:window.innerWidth>600?"30px":"10px"}}>
  {filteredReviews.length > 0 ? (
    <Slider {...sliderSettings}>
      {  reviews.map((review) => (
        <div style={{width:"100%",border:"1px solid black"}}>
        <div key={review.id} className="review-card" style={{width:"95%"}}>
          <div className="review-content" >
            <div className="review-header">
              <img src={review.avatar} alt={review.name} className="review-avatar" />
              <div className="review-info">
                <div className="review-meta">
                  <p className="reviewer-name" style={{fontSize:'18px',fontFamily:"Poppins",color:"black",fontWeight:500}}>{review.name}</p>
                  
                 
                </div>
                <div className="review-details">
                  <div className="rating-display">
                    {renderStars(review.rating)}
                    <span className="rating-number">{review.rating}.0</span>
                  </div>
                  <div className="date-display">
                    <Calendar className="date-icon" />
                    <span>
                      {new Date(review.date).toLocaleDateString("en-US", {
                        year: "numeric",
                        month: "short",
                        day: "numeric",
                      })}
                    </span>
                  </div>
                </div>
              </div>
            </div>
            <div className="review-text">
             <p className="reviewer-name" style={{fontSize:'18px',fontFamily:"Poppins"}}>{review.title}</p>
              <p className="review-description">{review.description}</p>
            </div>
          </div>
        </div></div>
      ))}
    </Slider>
  ) : (
    <div className="no-results">
      <div className="no-results-text">
        No reviews found matching your criteria.
      </div>
      <button
        onClick={() => {
          setSearchTerm("");
          setSelectedFilter("all");
        }}
        className="clear-filters-button"
      >
        Clear Filters
      </button>
    </div>
  )}
</div>


      {/* <Discover /> */}

      <Footer />

      <div className="js-pseudo-modal-template">
        <div className="modal fade" tabindex="-1" role="dialog">
          <div className="modal-dialog" role="document">
            <div className="modal-content">
              <div className="modal-header only-close">
                <div className="modal-title js-pseudo-modal-template-title-element h5"></div>
                <button
                  type="button"
                  className="btn-close close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                ></button>
              </div>
              <div className="modal-body js-pseudo-modal-template-content-element"></div>
            </div>
          </div>
        </div>
      </div>
      <div
        id="overlayCategoryModal0e9ee1f578ab4a3890b94947250a6521"
        className="d-none shield-advanced-category-overlay-modal bgweb2 f_shield-overlay-modal is_active"
        data-action="/en/widgets/cms/0e9ee1f578ab4a3890b94947250a6521"
        data-overlay-cms-page="true"
      >
        <div className="overlay-cms-top">
          <a
            href="javascript:void(0);"
            aria-label="close-modal"
            className="close-overlay-modal btn button-icon btn-highlighted js--close-overlay"
          >
            <i className="icon-close"></i>
          </a>
        </div>
        <div className="overlay-cms-inner js--overlay-cms-inner"></div>
      </div>
      <div data-mediameets-facebook-pixel-options='{"config":{"pixelIds":"247919152929715","privacyMode":"active","autoConfig":true,"advancedMatching":true,"includeShippingCosts":true,"useConversionApi":true,"disablePushState":true,"conversionApiDeduplication":"eventid"},"shop":{"controller":"navigation","action":"home","currency":"EUR"},"routes":{"customer":"\/en\/mm-fp\/customer","cart":"\/en\/mm-fp\/cart","order":"\/en\/mm-fp\/order"},"conversionApi":{"endpoint":"\/en\/mmfbpcapi"}}'></div>
      <script
        type="text/javascript"
        src="https://maps.googleapis.com/maps/api/js?key=AIzaSyA3TCkogy3gzKhdcm1RkR234Je3IoR7qeE&amp;libraries=places&amp;language=en-GB"
      ></script>
      <script>
        window.router['frontend.configurator.page'] = '/en/configurator';
        window.router['frontend.configurator.save'] = '/en/configurator/save';
        window.router['frontend.configurator.get-product-api-data'] =
        '/en/configurator/get-product-api-data';
        window.router['frontend.checkout.store-configurations'] =
        '/en/checkout/store-configurations';
        window.router['frontend.account.drafts.delete'] =
        '/en/account/drafts/delete';
        window.router['frontend.configurator.add-to-session'] =
        '/en/configurator/add-to-session';
        window.router['frontend.configurator.restore-in-session'] =
        '/en/configurator/restore-in-session';
        window.router['frontend.configurator.track-unique'] =
        '/en/configurator/track-unique';
        window.router['frontend.savings-calculator.fb-track'] =
        '/en/savings-calculator/fb-track';
        window.router['frontend.configurator.save-if-draft'] =
        '/en/configurator/save-if-draft';
        window.router['frontend.configurator.update-in-session'] =
        '/en/configurator/update-in-session';
        window.router['frontend.configurator.remove-from-session'] =
        '/en/configurator/remove-from-session';
        window.router['frontend.configurator.mail-desktop-link'] =
        '/en/configurator/mail-desktop-link';
        window.router['frontend.account.drafts.page'] = '/en/account/drafts';
        window.router['frontend.configurator.share'] = '/en/configurator/share';
        window.router['frontend.checkout.pre_cart.page'] =
        '/en/checkout/pre-cart'; window.router['frontend.checkout.cart.page'] =
        '/en/checkout/cart'; window.router['frontend.checkout.addressbook'] =
        '/en/widgets/checkout/address-book'; window.router['frontend.poll.save']
        = '/en/poll/save';
        window.router['frontend.account.teamshop.api.create-update-configuration']
        = '/en/account/teamshop/api/create-update-configuration';
        window.router['frontend.checkout.address.refresh'] =
        '/en/checkout/address/refresh';
        window.router['frontend.checkout.confirm'] = '/en/checkout/confirm';
        window.router['frontend.checkout.confirm.validate'] =
        '/en/checkout/confirm/validate';
        window.router['frontend.checkout.address.set-default-address'] =
        '/en/checkout/address/set-default-address';
        window.router['frontend.checkout.cross-selling-product-count'] =
        '/en/cross-selling/product-count';
        window.router['frontend.checkout.cross-selling.page'] =
        '/en/cross-selling/products';
        window.router['frontend.product.quantity-save-to-session'] =
        '/en/product/quantity-save-to-session';
        window.router['frontend.product.get-quantity-from-session'] =
        '/en/product/get-quantity-from-session';
        window.router['frontend.hreflang.get'] = '/en/hreflang/get';
        window.router['frontend.breadcrumb.get'] = '/en/breadcrumb/get';
        window.router['frontend.checkout.confirm.get-delivery-country-list'] =
        '/en/checkout/confirm/get-delivery-country-list';
        window.router['frontend.checkout.confirm.reload-cart-data'] =
        '/en/checkout/confirm/reload-cart-data';
        window.router['frontend.checkout.confirm.reload-cart-data'] =
        '/en/checkout/confirm/reload-cart-data';
        window.router['frontend.configurator.check-if-already-collapsed'] =
        '/en/configurator/check-if-already-collapsed';
        window.router['frontend.configurator.save-already-collapsed'] =
        '/en/configurator/save-already-collapsed';
      </script>
    </div>
  );
}

export default Home;
